import ApiResponse from '@/api/ApiResponse';
import config from '@/config';
import httpClient from '@/http';

export default class ApiBase {
  constructor() {
    this.httpClient = httpClient;
  }

  /**
   * Make http request
   *
   * @param  {string} method
   * @param  {string} url
   * @param  {Object} options
   * @return Promise
   */
  request(method, url, options = {}) {
    return this.httpClient.request({
      url: this.addIndicators(url),
      headers: {
        'X-Transaction-ID': config.transactionId,
      },
      method,
      ...options,
    }).then((response) => {
      return new ApiResponse(response);
    });
  }

  /**
   * Add the default indicators as query parameters
   *
   * @param {string} url
   * @returns {string}
   */
  addIndicators(url) {
    const urlObject = new URL(`${config.apiBaseUrl}/dashboard/${url}`);

    const indicatorsToAdd = {
      'currency': 'EUR',
      'liquid_indicator': 'mt',
      'weight_mass_indicator': 'mt',
    };

    Object.keys(indicatorsToAdd).forEach((indicator) => {
      if (!urlObject.searchParams.has(indicator)) {
        urlObject.searchParams.set(indicator, indicatorsToAdd[indicator]);
      }
    });

    return urlObject.pathname + urlObject.search;
  }
}
